/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './select-module';
export * from './select-animations';
export {
  MAT_SELECT_SCROLL_STRATEGY,
  MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY,
  MatSelectConfig,
  MAT_SELECT_CONFIG,
  MAT_SELECT_SCROLL_STRATEGY_PROVIDER,
  MatSelectChange,
  MAT_SELECT_TRIGGER,
  _MatSelectBase,
  MatSelect,
  MatSelectTrigger
} from './select';
